import { render, staticRenderFns } from "./btn-group.vue?vue&type=template&id=4845b8b6&scoped=true"
import script from "./btn-group.vue?vue&type=script&lang=js"
export * from "./btn-group.vue?vue&type=script&lang=js"
import style0 from "./btn-group.vue?vue&type=style&index=0&id=4845b8b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845b8b6",
  null
  
)

export default component.exports